export default __webpack_public_path__ + "static/media/Giant Rainbow, Buddha and People.9da9bddc.jpg";